import { useEffect, useState } from "react";
import { getDeletedBookings } from "../../services/formService";
import "./DeletedBookings.css";

const DeletedBookings = () => {
  const [deletedBookings, setDeletedBookings] = useState([]);
  const [sortField, setSortField] = useState("deletedAt"); // Default sorting by deletedAt
  const [sortOrder, setSortOrder] = useState("desc"); // Default order is Descending

  // Function to fetch deleted bookings
  const fetchDeletedBookings = async () => {
    const data = await getDeletedBookings();
    setDeletedBookings(data);
  };

  // Auto-fetch every 5 seconds
  useEffect(() => {
    fetchDeletedBookings();
    const interval = setInterval(fetchDeletedBookings, 5000);
    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  // Toggle sorting field and order
  const toggleSort = (field) => {
    if (sortField === field) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  // Sort data based on selected field and order
  const sortedBookings = [...deletedBookings].sort((a, b) => {
    return sortOrder === "asc"
      ? new Date(a[sortField]) - new Date(b[sortField])
      : new Date(b[sortField]) - new Date(a[sortField]);
  });

  return (
    <div className="deleted-bookings-container">
      <h2 className="title">Deleted Bookings</h2>

      <div className="sort-buttons">
        <button className="sort-button" onClick={() => toggleSort("startDate")}>
          Sort by Start Date (
          {sortOrder === "asc" && sortField === "startDate"
            ? "Descending ▲"
            : "Ascending ▼"}
          )
        </button>
        <button className="sort-button" onClick={() => toggleSort("deletedAt")}>
          Sort by Deleted At (
          {sortOrder === "asc" && sortField === "deletedAt" ? "▲" : "▼"})
        </button>
      </div>

      {sortedBookings.length === 0 ? (
        <p className="no-bookings">No deleted bookings found.</p>
      ) : (
        <div className="table-wrapper">
          <table className="deleted-bookings-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Contact</th>
                <th>Address</th>
                <th>Guest Count</th>
                <th>Total Price</th>
                <th>Start Date</th>
                <th>Deleted At</th>
                <th>Cart Items</th>
              </tr>
            </thead>
            <tbody>
              {sortedBookings.map((booking) => (
                <tr key={booking._id}>
                  <td>{booking.name}</td>
                  <td>{booking.email}</td>
                  <td>{booking.contactNumber}</td>
                  <td>{booking.address}</td>
                  <td>{booking.guestCount}</td>
                  <td>₱{booking.totalPrice.toLocaleString()}</td>
                  <td>
                    {new Date(booking.startDate).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })}
                  </td>

                  <td>
                    {new Date(booking.deletedAt).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })}{" "}
                    {new Date(booking.deletedAt).toLocaleTimeString("en-US", {
                      hour: "numeric",
                      minute: "2-digit",
                      hour12: true,
                    })}
                  </td>

                  <td>
                    <ul>
                      {booking.cart.map((item, index) => (
                        <li key={index}>
                          <strong>{item.name}</strong> - {item.quantity} × ₱
                          {item.price.toLocaleString()}
                        </li>
                      ))}
                    </ul>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default DeletedBookings;
